import { render, staticRenderFns } from "./virtuals.vue?vue&type=template&id=b9616e08&"
import script from "./virtuals.vue?vue&type=script&lang=js&"
export * from "./virtuals.vue?vue&type=script&lang=js&"
import style0 from "./virtuals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports